"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SignInDialog = SignInDialog;
var _Button2 = _interopRequireDefault(require("@mui/material/Button"));
var _Divider2 = _interopRequireDefault(require("@mui/material/Divider"));
var _DialogTitle2 = _interopRequireDefault(require("@mui/material/DialogTitle"));
var _Dialog2 = _interopRequireDefault(require("@mui/material/Dialog"));
var _DialogContent2 = _interopRequireDefault(require("@mui/material/DialogContent"));
var _Fab2 = _interopRequireDefault(require("@mui/material/Fab"));
var _GridLegacy2 = _interopRequireDefault(require("@mui/material/GridLegacy"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _IconButton2 = _interopRequireDefault(require("@mui/material/IconButton"));
var _Close2 = _interopRequireDefault(require("@mui/icons-material/Close"));
var _useMediaQuery2 = _interopRequireDefault(require("@mui/material/useMediaQuery"));
var _styles = require("@mui/material/styles");
var _moment = _interopRequireDefault(require("moment"));
var _notistack = require("notistack");
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = require("styled-components");
var _apps = _interopRequireDefault(require("../../assets/images/apps.png"));
var _geoveloLogoText = _interopRequireDefault(require("../../assets/images/geovelo-logo-text.svg"));
var _hooks = require("../../hooks");
var _icons = require("../icons");
var _signInForm = _interopRequireDefault(require("./sign-in-form"));
var _signUpForm = _interopRequireDefault(require("./sign-up-form"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function SignInDialog({
  widgetConfig,
  onRegistered,
  onSignedIn,
  onClose,
  ...props
}) {
  const [displayedForm, displayForm] = (0, _react.useState)('sign-in');
  const {
    t,
    i18n: {
      language: currentLanguage
    }
  } = (0, _reactI18next.useTranslation)();
  const theme = (0, _styles.useTheme)();
  const isSmall = (0, _useMediaQuery2.default)(theme.breakpoints.down('md'));
  const {
    enqueueSnackbar
  } = (0, _notistack.useSnackbar)();
  const {
    facebookSignIn,
    googleSignIn,
    appleSignIn
  } = (0, _hooks.useSignIn)();
  (0, _react.useEffect)(() => {
    if (props.open) {
      displayForm('sign-in');
    }
  }, [props.open]);
  function close(user) {
    // TODO: ask a better solution to backend developer
    if ((0, _moment.default)().diff(user.created, 'milliseconds') > 5000) onSignedIn(user);else onRegistered(user);
  }
  async function handleFacebookSignIn() {
    try {
      const user = await facebookSignIn(currentLanguage);
      close(user);
    } catch (err) {
      console.error(err);
      enqueueSnackbar(t('commons.sign_in_dialog.server_error'));
    }
  }
  async function handleGoogleSignIn() {
    try {
      const user = await googleSignIn(currentLanguage);
      close(user);
    } catch (err) {
      console.error(err);
      enqueueSnackbar(t('commons.sign_in_dialog.server_error'));
    }
  }
  async function handleAppleSignIn() {
    try {
      const user = await appleSignIn(currentLanguage);
      close(user);
    } catch (err) {
      console.error(err);
      enqueueSnackbar(t('commons.sign_in_dialog.server_error'));
    }
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Dialog2.default, _extends({
    fullWidth: true,
    maxWidth: "md",
    onClose: () => onClose(),
    scroll: "paper",
    slotProps: {
      paper: {
        sx: {
          borderRadius: 4
        }
      }
    }
  }, props), /*#__PURE__*/_react.default.createElement(StyledDialogTitle, null, /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    placement: "left",
    title: /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.actions.close"
    })
  }, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
    onClick: () => onClose(),
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_Close2.default, {
    fontSize: "small"
  })))), /*#__PURE__*/_react.default.createElement(_DialogContent2.default, null, /*#__PURE__*/_react.default.createElement(ContentWrapper, null, /*#__PURE__*/_react.default.createElement(StyledLogo, {
    alt: "Logo Geovelo",
    src: _geoveloLogoText.default
  }), /*#__PURE__*/_react.default.createElement(_GridLegacy2.default, {
    container: true,
    direction: isSmall ? 'column-reverse' : 'row',
    spacing: 4
  }, /*#__PURE__*/_react.default.createElement(_GridLegacy2.default, {
    item: true,
    md: 6,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    gutterBottom: true,
    color: "primary",
    variant: "h5"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.sign_in_dialog.title"
  })), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary",
    variant: "caption"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.sign_in_dialog.description"
  })), /*#__PURE__*/_react.default.createElement(StyledAppsImage, {
    alt: "Geovelo apps",
    src: _apps.default
  })), /*#__PURE__*/_react.default.createElement(_GridLegacy2.default, {
    item: true,
    md: 6,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(SSOButtonsWrapper, null, /*#__PURE__*/_react.default.createElement(_Fab2.default, {
    disableRipple: true,
    onClick: handleAppleSignIn,
    style: {
      backgroundColor: '#000',
      color: '#fff',
      boxShadow: 'none'
    }
  }, /*#__PURE__*/_react.default.createElement(_icons.AppleIcon, {
    color: "inherit"
  })), /*#__PURE__*/_react.default.createElement(_Fab2.default, {
    disableRipple: true,
    onClick: handleFacebookSignIn,
    style: {
      backgroundColor: '#485a96',
      color: 'white',
      boxShadow: 'none'
    }
  }, /*#__PURE__*/_react.default.createElement(_icons.FacebookIcon, {
    color: "inherit"
  })), /*#__PURE__*/_react.default.createElement(_Fab2.default, {
    disableRipple: true,
    onClick: handleGoogleSignIn,
    style: {
      backgroundColor: 'white',
      border: '1px solid #ccc',
      boxShadow: 'none'
    }
  }, /*#__PURE__*/_react.default.createElement(_icons.GoogleIcon, null))), /*#__PURE__*/_react.default.createElement(FormWrapper, null, displayedForm === 'sign-in' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledSignInForm, {
    onSignedIn: onSignedIn
  }), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    align: "center",
    color: "textSecondary",
    component: "p",
    variant: "caption"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    components: [/*#__PURE__*/_react.default.createElement(_Typography2.default, {
      color: "primary",
      component: "a",
      href: "https://geovelo.app/forgot-password/",
      key: 0,
      target: "_blank",
      variant: "caption"
    })],
    i18nKey: "commons.sign_in_form.forgot_password"
  })), /*#__PURE__*/_react.default.createElement(StyledDivider, null), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    align: "center",
    color: "textSecondary",
    component: "p",
    variant: "caption"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.sign_in_dialog.not_registered"
  })), /*#__PURE__*/_react.default.createElement(StyledButton, {
    onClick: () => displayForm('sign-up'),
    size: "medium",
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.actions.sign_up"
  }))), displayedForm === 'sign-up' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledSignUpForm, {
    onRegistered: onRegistered,
    widgetConfig: widgetConfig
  }), /*#__PURE__*/_react.default.createElement(StyledDivider, null), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    align: "center",
    color: "textSecondary",
    component: "p",
    variant: "caption"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.sign_in_dialog.already_registered"
  })), /*#__PURE__*/_react.default.createElement(StyledButton, {
    onClick: () => displayForm('sign-in'),
    size: "medium",
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.actions.sign_in"
  }))))))))));
}
const StyledDialogTitle = (0, _styledComponents.styled)(_DialogTitle2.default)`
  display: flex;
  justify-content: flex-end;
`;
const ContentWrapper = _styledComponents.styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 16px 16px;
`;
const StyledLogo = _styledComponents.styled.img`
  align-self: center;
  margin-bottom: 48px;
  width: 96px;
`;
const StyledAppsImage = _styledComponents.styled.img`
  margin-top: 16px;
  width: calc(100% - 32px);
`;
const SSOButtonsWrapper = _styledComponents.styled.div`
  display: flex;
  justify-content: space-evenly;
  margin-bottom: 16px;
`;
const FormWrapper = _styledComponents.styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;
const formStyle = (0, _styledComponents.css)`
  margin: 0 auto 16px;
  max-width: 350px;
  width: 100%;
`;
const StyledSignInForm = (0, _styledComponents.styled)(_signInForm.default)`
  ${formStyle};
`;
const StyledDivider = (0, _styledComponents.styled)(_Divider2.default)`
  && {
    margin: 16px 0;
    width: 100%;
  }
`;
const StyledButton = (0, _styledComponents.styled)(_Button2.default)`
  && {
    margin-top: 8px;
    max-width: 350px;
    width: 100%;
  }
`;
const StyledSignUpForm = (0, _styledComponents.styled)(_signUpForm.default)`
  ${formStyle};
`;